import { useEffect, useState } from "react";
import { css } from "@emotion/react";

import { Alert, Link, Text } from "@zapier/design-system";

import { MassActionMessage } from "@zapier/reporting/src/hooks";

type Props = {
  message: MassActionMessage | null;
};

const bodyItemStyle = css`
  display: list-item;
  margin-left: 20px;
`;

const rootStyle = css`
  margin-bottom: 20px;
`;

export function MassActionResults({ message }: Props) {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (hide) {
      setHide(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message?.id, setHide]);

  if (!message || hide) {
    return null;
  }

  return (
    <div css={rootStyle}>
      <Alert
        onDismiss={() => {
          setHide(true);
        }}
        status={message?.messageType || "info"}
      >
        {(message.title || message.text) && (
          <span>
            <Text color="GrayWarm10" type="Body3">
              {message.title}
            </Text>
            {message.text && (
              <span>
                {" "}
                <Text color="GrayWarm9" type="Body1">
                  {message.text}
                </Text>
                {message.link && (
                  <>
                    {" "}
                    <Link href={message.link.href}>{message.link.text}</Link>
                  </>
                )}
              </span>
            )}
          </span>
        )}
        {message.body && (
          <ul>
            {message.body.map((item, i: number) => (
              <li css={bodyItemStyle} key={i}>
                <Text color="GrayWarm10" type="Body1">
                  {item.message}
                </Text>
                {item.link && (
                  <>
                    {" "}
                    <Link href={item.link.href}>
                      <Text color="TextLink" type="Body1">
                        {item.link.text}
                      </Text>
                    </Link>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </Alert>
    </div>
  );
}
